import { useQuery } from '@tanstack/react-query'
import handbookService from '@/services/handbookService'
import { useApiReady } from '@/hooks/useApiReady'

// Query keys
export const handbooksKeys = {
  all: ['handbooks'] as const,
  lists: () => [...handbooksKeys.all, 'list'] as const,
  list: (params: any) => [...handbooksKeys.lists(), params] as const,
}

interface HandbooksFilters {
  page?: number
  pageSize?: number
  search?: string
  team_id?: string
}

/**
 * Hook pour récupérer la liste des handbooks
 */
export function useHandbooks(filters: HandbooksFilters, options?: { enabled?: boolean }) {
  const apiReady = useApiReady()

  return useQuery({
    queryKey: handbooksKeys.list({
      page: filters.page,
      pageSize: filters.pageSize,
      search: filters.search,
      teamId: filters.team_id,
    }),
    queryFn: async () => {
      const paramsWithTeam = {
        page: filters.page,
        pageSize: filters.pageSize,
        search: filters.search,
        team_id: filters.team_id || undefined,
      }

      const response = await handbookService.getHandbooks(paramsWithTeam)
      
      if (response.success) {
        const payload = response.data || {}
        return {
          list: payload.list || [],
          total: payload.total ?? payload.list?.length ?? 0,
          pageSize: payload.pageSize ?? filters.pageSize,
        }
      }

      return { list: [], total: 0, pageSize: filters.pageSize || 10 }
    },
    enabled: apiReady && options?.enabled !== false,
  })
}
